var _path, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBackground(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 607,
    height: 607,
    viewBox: "0 0 607 607",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1310_24204)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1310_24204",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -96,
    y: -96,
    width: 800,
    height: 800
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M704 -96H-96V704H704V-96Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1310_24204)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M100.793 507.208C-11.4362 394.979 -11.4362 213.021 100.793 100.792C213.022 -11.4369 394.98 -11.4369 507.209 100.792C619.438 213.021 619.438 394.979 507.209 507.208C394.98 619.437 213.022 619.437 100.793 507.208Z",
    fill: "#661A02"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.793 507.208C-11.4362 394.979 -11.4362 213.021 100.793 100.792C213.022 -11.4369 394.98 -11.4369 507.209 100.792C619.438 213.021 619.438 394.979 507.209 507.208C394.98 619.437 213.022 619.437 100.793 507.208Z",
    stroke: "#3A1200",
    strokeWidth: 31,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M580.791 304C580.791 456.868 456.868 580.791 304 580.791C151.132 580.791 27.209 456.868 27.209 304C27.209 151.132 151.132 27.2091 304 27.2091C456.868 27.2091 580.791 151.132 580.791 304Z",
    stroke: "#FFEC06",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.706 56.9411C307.706 67.7591 305.81 76.5291 303.471 76.5291C301.132 76.5291 299.236 67.7591 299.236 56.9411C299.236 46.1231 301.132 37.3531 303.471 37.3531C305.81 37.3531 307.706 46.1231 307.706 56.9411Z",
    fill: "#E2AF40"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.925 126.682C139.575 134.332 144.435 141.874 142.781 143.528C141.127 145.182 133.585 140.322 125.935 132.672C118.285 125.022 113.425 117.48 115.079 115.826C116.733 114.172 124.275 119.032 131.925 126.682Z",
    fill: "#E2AF40"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.9415 300.294C67.7595 300.294 76.5295 302.19 76.5295 304.529C76.5295 306.868 67.7595 308.764 56.9415 308.764C46.1235 308.764 37.3535 306.868 37.3535 304.529C37.3535 302.19 46.1235 300.294 56.9415 300.294Z",
    fill: "#E2AF40"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.683 476.076C134.333 468.426 141.875 463.566 143.529 465.22C145.183 466.874 140.323 474.416 132.673 482.066C125.023 489.716 117.481 494.576 115.827 492.922C114.173 491.268 119.033 483.726 126.683 476.076Z",
    fill: "#E2AF40"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.295 551.059C300.295 540.241 302.191 531.471 304.53 531.471C306.869 531.471 308.765 540.241 308.765 551.059C308.765 561.877 306.869 570.647 304.53 570.647C302.191 570.647 300.295 561.877 300.295 551.059Z",
    fill: "#E2AF40"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M476.076 481.318C468.426 473.668 463.566 466.126 465.22 464.472C466.874 462.818 474.416 467.678 482.066 475.328C489.716 482.978 494.576 490.52 492.922 492.174C491.268 493.828 483.726 488.968 476.076 481.318Z",
    fill: "#E2AF40"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M551.059 307.706C540.241 307.706 531.471 305.81 531.471 303.471C531.471 301.132 540.241 299.236 551.059 299.236C561.877 299.236 570.647 301.132 570.647 303.471C570.647 305.81 561.877 307.706 551.059 307.706Z",
    fill: "#E2AF40"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M481.319 131.924C473.669 139.574 466.127 144.434 464.473 142.78C462.819 141.126 467.679 133.584 475.329 125.934C482.979 118.284 490.521 113.424 492.175 115.078C493.829 116.732 488.969 124.274 481.319 131.924Z",
    fill: "#E2AF40"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.908 68.2931L242.497 73.4201L247.624 62.8311L237.035 57.7041L231.908 68.2931Z",
    fill: "#E2AF40"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.359 94.9841L184.914 97.1951L187.125 85.6401L175.57 83.4291L173.359 94.9841Z",
    fill: "#E2AF40"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.3542 188.306L97.4662 184.444L93.6042 173.332L82.4922 177.194L86.3542 188.306Z",
    fill: "#E2AF40"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.8257 248.58L73.5607 241.973L66.9537 232.238L57.2188 238.845L63.8257 248.58Z",
    fill: "#E2AF40"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.2921 376.091L73.4191 365.502L62.8301 360.375L57.7031 370.964L68.2921 376.091Z",
    fill: "#E2AF40"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.9847 434.64L97.1957 423.085L85.6407 420.874L83.4297 432.429L94.9847 434.64Z",
    fill: "#E2AF40"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.306 521.646L184.444 510.534L173.332 514.396L177.194 525.508L188.306 521.646Z",
    fill: "#E2AF40"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.58 544.174L241.973 534.439L232.238 541.046L238.845 550.781L248.58 544.174Z",
    fill: "#E2AF40"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.091 539.707L365.502 534.58L360.375 545.169L370.964 550.296L376.091 539.707Z",
    fill: "#E2AF40"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434.639 513.016L423.084 510.805L420.873 522.36L432.428 524.571L434.639 513.016Z",
    fill: "#E2AF40"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M521.645 419.694L510.533 423.556L514.395 434.668L525.507 430.806L521.645 419.694Z",
    fill: "#E2AF40"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M544.174 359.42L534.439 366.027L541.046 375.762L550.781 369.155L544.174 359.42Z",
    fill: "#E2AF40"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M539.707 231.909L534.58 242.498L545.169 247.625L550.296 237.036L539.707 231.909Z",
    fill: "#E2AF40"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M513.016 173.36L510.805 184.915L522.36 187.126L524.571 175.571L513.016 173.36Z",
    fill: "#E2AF40"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419.693 86.3541L423.555 97.4661L434.667 93.6041L430.805 82.4921L419.693 86.3541Z",
    fill: "#E2AF40"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.42 63.8261L366.027 73.5611L375.762 66.9541L369.155 57.2191L359.42 63.8261Z",
    fill: "#E2AF40"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1310_24204"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 607,
    height: 607,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackground);
export default __webpack_public_path__ + "static/media/background.a7eadc5498fe03a12e4684cd77a7924f.svg";
export { ForwardRef as ReactComponent };